import React, { useState, forwardRef } from "react";
import { Input } from "./ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with a show/hide toggle.
 * Wraps shadcn `Input` — forwards all props (value, onChange, required, data-testid, etc.)
 */
const PasswordInput = forwardRef(function PasswordInput({ className = "", ...rest }, ref) {
  const [shown, setShown] = useState(false);
  const testid = rest["data-testid"] || "password-input";
  return (
    <div className="relative">
      <Input
        ref={ref}
        {...rest}
        type={shown ? "text" : "password"}
        className={`pr-10 ${className}`}
      />
      <button
        type="button"
        onClick={() => setShown(s => !s)}
        aria-label={shown ? "Hide password" : "Show password"}
        data-testid={`${testid}-toggle`}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-slate-400 hover:text-[#ea580c] focus:outline-none focus:text-[#ea580c]"
      >
        {shown ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});
export default PasswordInput;
